/**
 * Tag da utilizzare per esporre elementi dentro un form react-admin evitando
 * warning/errori dovuti all'injection di props che non sono compatibili
 * con il DOM.
 */
const SafeTag = ({ children, ...props }) => children;
export default SafeTag;
